// The deploy token is minted at build time in vite.config.ts (see
// mintDeployToken there) and proves to the workers that a request came from a
// recent build of this app. Sent on every API call; workers gate on it via
// DEPLOY_TOKEN_ENFORCEMENT.
export const deployTokenHeader: Record<string, string> = __T2E_DEPLOY_TOKEN__
   ? { 'X-T2E-Client': __T2E_DEPLOY_TOKEN__ }
   : {}

// Identifies which build this tab is running. Distinct per deploy, since the
// token carries the build time and commit sha. lib/stale-bundle-reload.ts keys
// its one-reload-per-bundle guard on it — reloading can only ever help if it
// lands the tab on a *different* build, so this is the thing worth comparing.
export const deployTokenId: string = __T2E_DEPLOY_TOKEN__ ?? ''
